<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="medium" v-on:submit.prevent>
        <div class="content-name">
          <h2 class="dp-ib">{{ routeName }}</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-check" v-show="btnSaveVisible" @click="save">
              환입저장
            </el-button>
            <el-button type="danger" icon="el-icon-close"  v-show="btnCancelVisible" @click="cancel">
              환입취소
            </el-button>
            <el-button type="primary" icon="el-icon-search" @click="goOpen">
              {{ this.$i18n.messages[this.$store.state.locale].search }}
            </el-button>
            <el-button type="success" icon="el-icon-document-checked" @click="excelDown">엑셀</el-button>
          </el-form-item>
        </div>
      </el-form>

      <div class="search-form">
        <el-form size="mini">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="12">
              <el-form-item :gutter="20">
                <el-col :span="5">
                  <el-select v-model="form.dtType">
                    <el-option value='OUT' label="요청기간"></el-option>
                    <el-option value='IN' label="환입기간"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="7" style="padding-right: 0px;">
                  <el-date-picker type="date" placeholder="시작일" v-model="form.startDt" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
                </el-col>
                <el-col :span="1" style="text-align: center;">-</el-col>
                <el-col :span="7">
                  <el-date-picker type="date" placeholder="종료일" v-model="form.endDt" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
                </el-col>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-row>
                <el-form-item label="지역/센터">
                  <el-col :span="8">
                    <el-select v-model="form.catId" @change="onCatIdChange">
                      <el-option value='' label="전체">전체</el-option>
                      <el-option
                          v-for="item in combos['catId']"
                          :key="item.key"
                          :value="item.key"
                          :label="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="12">
                    <el-select v-model="form.subCatId" v-show="changeCatIdShow">
                      <el-option value='' label="전체">전체</el-option>
                      <el-option
                          v-for="item in combos['subCatId']"
                          :key="item.key"
                          :value="item.key"
                          :label="item.value">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0px;">
            <el-col :span="12">
              <el-form-item label="품번">
                <el-input type="text" v-model="form.itemCd" style="width: 70%;" @keyup.native.enter="goOpen"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="처리상태">
                <el-select v-model="form.procYn">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['procYn']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="환입구분">
                <el-select v-model="form.outType">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['outType']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

    <div class="table-area mt20">
      <div class="table-b">
        <div class="table-header">
        </div>
      </div>
    </div>

    <div class="table-area">
      <div class="table-b">
        <div class="table-header">
          <div class="grid-tbl-box">
            <ag-grid-vue
                ref="grid"
                :style="gridStyle"
                class="ag-theme-alpine"
                :column-defs="columnDefs"
                :grid-options="mainGridOptions"
                :row-data="data"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                :statusBar="statusBar"
                :enableRangeSelection="true"
                @grid-ready="onReadyMain" />
          </div>

          <div class="grid-tbl-box" v-show="false">
            <ag-grid-vue
                ref="excelGrid"
                :style="gridStyle"
                class="ag-theme-alpine"
                :column-defs="excelColumnDefs"
                :grid-options="excelGridOptions"
                :row-data="excelData"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                @grid-ready="onReadyExcel"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
import InputCellRender from "@/components/agGrid/input-cell-renderer";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";

import mixin from "@/mixin/lucoms";

function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  props: {
  },
  mixins: [mixin],
  data() {
    return {
      data: [],
      result: [],
      excelData: [],
      form: {
        companyId : '',
        dtType : 'OUT',   //기간구분
        startDt: this.$moment().format('YYYY-MM-DD'),
        endDt: this.$moment().format('YYYY-MM-DD'),
        catId : '',              // 지역
        subCatId: '',          // 지역 상세
        itemCd : '',             // 품번
        outType : '',            // 환입구분
        confirmYn : '',
        procYn : '',             // 처리상태
        sortType : '',           // 승인/정산처리유형
        page : 1,
        totalPage : 9999,
        curPage : 0,
        totalCount : 9999,
        processTime : ''
      },
      combos: {
        'catId' : [],
        'procYn' : [],
        'outType' : [],
        'subCatId' : [],
      },
      changeCatIdShow : false,
      //startDt: this.$moment().add(-1, 'month').startOf('month').format('YYYY-MM-DD'),
      //endDt: this.$moment().format('YYYY-MM-DD'),
      // AG-GRID OPTION [START]
      gridStyle : 'padding-top: 0px; width: 100%;height: 650px; min-height:100px;',
      defaultColDef: {
          resizable: true
        , filter:true
        , sortable: true
      },
      mainGridApi: null,
      mainColumnApi: null,
      mainGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      excelGridApi: null,
      excelColumnApi: null,
      excelGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
        excelStyles: [
          { id: 'numberType',numberFormat: {format: '0',}},
          { id: 'stringType', dataType: 'String'},
          { id: 'dateType', dataType: 'DateTime'},
        ],
      },
      columnDefs: [],
      excelColumnDefs: [],
      frameworkComponent : {
        datePicker: DatepickerCellRenderer,
        maskEdit: MaskEditCellRenderer,
        select: SelectCellRenderer,
        checkBox: CheckboxCellRenderer,
        radio: RadioCellRenderer,
        numberInput: NumberInputCellRender,
        input: InputCellRender,
        button: ButtonCellRenderer
      },
      statusBar: null,
      btnSaveVisible : false,
      btnCancelVisible : false
    }
  },
  methods: {
    onReadyMain() {
      this.mainGridApi = this.mainGridOptions.api;
      this.mainColumnApi = this.mainGridOptions.columnApi;

      this.init();
    },
    onReadyExcel() {
      this.excelGridApi = this.excelGridOptions.api;
      this.excelColumnApi = this.excelGridOptions.columnApi;
    },
    createMainColumnDefs() {
      this.columnDefs = [
        {
          headerName:'No',
          field:'no',
          width:80,
          cellStyle:{textAlign: 'center'},
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          }
        },
        {headerName:'센터명', field:'outAsAgentNm', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'장애처리일자', field:'procDt', width:130, cellStyle:{textAlign: 'center'},
          cellRenderer: (params) => {
            return params.value = params.value === null  ? '' : this.getDateFormat(`${params.value}`) ;
          }},
        {headerName:'요청일자', field:'outDt', width:120, cellStyle:{textAlign: 'center'},
          cellRenderer: (params) => {
            return params.value = params.value === null  ? '' : this.getDateFormat(`${params.value}`) ;
          }},
        {headerName:'환입일자', field:'inDt', width:120, cellStyle:{textAlign: 'center'},
          cellRenderer: (params) => {
            return params.value = params.value === null  ? '' : this.getDateFormat(`${params.value}`) ;
          }},
        {headerName:'자재구분', field:'outType', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'제조사', field:'makerNm', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'제품군', field:'itemGroupNm', width:110, cellStyle:{textAlign: 'left'}},
        {headerName:'품번', field:'itemCd', width:180},
        {headerName:'품명', field:'itemNm', width:250},
        {headerName:'수량', field:'goodQty', width:80, cellStyle:{textAlign: 'right'},
          valueGetter: (params) => {
            if(params.data.outType === '불량자재') {
              return params.data.badQty;
            } else {
              return params.data.goodQty;
            }
          }
        },
        {headerName:'유무상', field:'costYn', width:110, cellStyle:{textAlign: 'center'},
          valueGetter: (params) => {
            return params.data.outType !== "불량자재" ? "" : (params.data.processPayYn === 'Y' ? "유상" : "무상")
          }
        },
        {headerName:'처리상태', field:'procYn', width:110, cellStyle:{textAlign: 'center'},
          valueGetter: (params) => {
            return params.data.procYn === 'Y' ? "환입완료" : "미환입"
          }
        },
        {headerName: '선택', field: 'chk', width: 80, cellRenderer: 'checkBox',
          cellRendererParams: {
              trueValue: 'Y'    //true값  지정 defalut-"Y" ex) "Y", true, "1"
            , falseValue: 'N'  //false값 지정 defalut-"N" ex) "N", false, "0"
            , disable: false
          },
        },
      ];
    },
    createExcelColumnDefs() {
      const that = this;
      this.excelColumnDefs = [
        {headerName:'센터명', field:'outAsAgentNm', width:110, cellStyle:{textAlign: 'center'}, cellClass: 'stringType'},
        {headerName:'장애처리일자', field:'procDt', width:130, cellStyle:{textAlign: 'center'},
          cellRenderer: (params) => {
            return params.value = params.value === null  ? '' : this.getDateFormat(`${params.value}`) ;
          }},
        {headerName:'요청일자', field:'outDt', width:120, cellStyle:{textAlign: 'center'},
          cellRenderer: (params) => {
            return params.value = params.value === null  ? '' : this.getDateFormat(`${params.value}`) ;
          }},
        {headerName:'환입일자', field:'inDt', width:120, cellStyle:{textAlign: 'center'},
          cellRenderer: (params) => {
            return params.value = params.value === null  ? '' : this.getDateFormat(`${params.value}`) ;
          }},
        {headerName:'자재구분', field:'outType', width:110, cellStyle:{textAlign: 'center'}, cellClass: 'stringType'},
        {headerName:'제조사', field:'makerNm', width:110, cellStyle:{textAlign: 'center'}, cellClass: 'stringType'},
        {headerName:'제품군', field:'itemGroupNm', width:110, cellStyle:{textAlign: 'left'}, cellClass: 'stringType'},
        {headerName:'품번', field:'itemCd', width:180, cellClass: 'stringType'},
        {headerName:'품명', field:'itemNm', width:250, cellClass: 'stringType'},

        {headerName:'규격', field:'itemSpec', width:250, cellClass: 'stringType'},
        {headerName:'이평단가', field:'unitPrice1', width:250},
        {headerName:'수량', field:'goodQty', width:80, cellStyle:{textAlign: 'right'},
          valueGetter: (params) => {
            //return params.data.goodQty + params.data.recycleQty + params.data.badQty
            if(params.data.outType === '불량자재') {
              return params.data.badQty;
            } else {
              return params.data.goodQty;
            }
          }
        },
        {headerName:'이평금액', field:'goodQty', width:80, cellStyle:{textAlign: 'right'},
          valueGetter: (params) => {
            let qtyAmt = 0;
            if(params.data.outType === '불량자재') {
              qtyAmt = parseInt(params.data.unitPrice1 || 0) * parseInt(params.data.badQty || 0);
            } else {
              qtyAmt = parseInt(params.data.unitPrice1 || 0) * parseInt(params.data.goodQty || 0);
            }
            return `${qtyAmt}`
          }
        },
        {headerName:'유무상', field:'costYn', width:110, cellStyle:{textAlign: 'center'},
          valueGetter: (params) => {
            return params.data.outType !== "BadItem" ? "" : (params.data.processPayYn === 'Y' ? "유상" : "무상")
          }
        },
        {headerName:'처리상태', field:'procYn', width:110, cellStyle:{textAlign: 'center'},
          valueGetter: (params) => {
            return params.data.procYn === 'Y' ? "환입완료" : "미환입"
          }
        }
      ];
    },
    $dismiss() {
      this.$emit('dismiss')
      this.$parent.close()
    },
    goOpen() {
      let that = this
      this.$store.commit('loading')

      const vForm = {
        companyId :this.form.companyId,
        dtType : this.form.dtType,                                  //기간구분
        startDt: this.form.startDt,
        endDt: this.form.endDt,
        catId : (this.form.subCatId.length <= 0 || this.form.subCatId === '')  ? (this.form.catId === '' ? 0 : this.form.catId) : this.form.subCatId,          // 지역
        subCatId: this.form.subCatId,                    // 지역 상세
        itemCd : this.form.itemCd,                       // 품번
        outType : this.form.outType,                     // 환입구분
        confirmYn : this.form.confirmYn,
        procYn : this.form. procYn,                      // 처리상태
        sortType : this.form.sortType,                   // 승인/정산처리유형
        page : this.form.page,
        totalPage : this.form.totalPage,
        curPage : this.form.curPage,
        totalCount : this.form.totalCount,
        processTime : this.form.processTime
      }
      this.$http.post(_url("/api/workMng/mateReEntering/list"), vForm)
          .then(response => {
            that.data = response.data
            /* data customize */
            this.changeData();
      }).finally(() => {
        this.btnSaveChk();
        this.btnCancelChk();
        this.$store.commit('finish')
      });
    },
    save() {
      //event.preventDefault()
      var list = this.data.filter(v => v.chk === 'Y')
      this.result = [];
      if(list.length > 0){
        this.$swal({
          type: 'question',
          text: '선택한 항목을 환입저장을 하시겠습니까?',
          showCancelButton: true
        }).then(r => {
          if (r.value) {
            this.$store.commit('loading')
            this.result = list;
            this.$http.post(_url(`/api/workMng/mateReEntering/save`), this.result)
                .then((response) => {
                  this.$swal({ type: 'success', text: '환입 저장을 했습니다.' })
                      .then((result) => {
                        if (result.value) {
                          this.goOpen();
                        }
                      });
                })
                .catch((e) => {
                  this.$swal({ type: 'success', text: '환입 저장을 실패 했습니다.' })
                })
                .finally(() => {
                  this.$store.commit('finish')
                });
          }
        })
      } else {
        this.$swal({ type: 'info', text: '저장할 항목을 선택하세요.' });
      }
    },
    cancel() {
      //event.preventDefault()
      var list = this.data.filter(v => v.chk === 'Y')
      this.result = [];
      if(list.length > 0){
        this.$swal({
          type: 'question',
          text: '선택한 항목을 환입취소를 하시겠습니까?',
          showCancelButton: true
        }).then(r => {
          if (r.value) {
            this.$store.commit('loading')
            this.result = list;
            this.$http.post(`/api/workMng/mateReEntering/cancel`, this.result)
                .then((response) => {
                  this.$swal({ type: 'success', text: '환입 취소를 했습니다.' })
                      .then((result) => {
                        if (result.value) {
                          this.goOpen();
                        }
                      });
                })
                .catch((e) => {
                  this.$swal({ type: 'success', text: '환입 취소를 실패 했습니다.' })
                })
                .finally(() => {
                  this.$store.commit('finish')
                });
          }
        })
      } else {
        this.$swal({ type: 'info', text: '취소할 항목을 선택하세요.' });
      }
    },
    init() {
      this.$store.commit('loading');
      this.$http.post(`/api/workMng/mateReEntering/init`)
          .then(response => {
            this.combos['catId'] = response.data.catId;
            this.combos['procYn'] = response.data.procYn;
            this.combos['outType'] = response.data.outType;
          }).finally(() => {
            this.$store.commit('finish');
            this.goOpen();
          });
      this.createMainColumnDefs();
      this.createExcelColumnDefs();
    },
    onCatIdChange(param){
      this.form.subCatId = '';
      if(param === '') this.changeCatIdShow =  false;
      else{
        this.changeCatIdShow =  true;
        // 지역 상세
        this.$http.get(`/api/codeMng/combo/catId`, { params: {parentId: param} })
            .then(response => {
              this.combos['subCatId'] = response.data || []
            });
      }
    },
    btnSaveChk(){
      if(this.form.procYn === 'N'){
        this.btnSaveVisible = true;
        this.btnCancelVisible = false;
      } else if (this.form.procYn === 'Y'){
        this.btnSaveVisible = false;
        this.btnCancelVisible = true;
      } else {
        this.btnSaveVisible = false;
        this.btnCancelVisible = false;
      }
    },
    btnCancelChk(){
      if(this.form.procYn === 'Y'){
        this.btnCancelVisible = true;
        this.btnSaveVisible = false;
      } else if(this.form.procYn === 'N'){
        this.btnCancelVisible = false;
        this.btnSaveVisible = true;
      } else {
        this.btnSaveVisible = false;
        this.btnCancelVisible = false;
      }
    },
    /* data customize */
    changeData(){
      this.data.map((x, i) => {
        let filter = this.combos['outType'].filter(y => y.key === x.outType);
        x.outType = filter[0].value;
      })

      this.excelData.map((x, i) => {
        let filter = this.combos['outType'].filter(y => y.key === x.outType);
        x.outType = filter[0].value;
      })
    },
    excelDown(){

      const vForm = {
        companyId :this.form.companyId,
        dtType : this.form.dtType,                                  //기간구분
        startDt: this.form.startDt,
        endDt: this.form.endDt,
        catId : (this.form.subCatId.length <= 0 || this.form.subCatId === '')  ? (this.form.catId === '' ? 0 : this.form.catId) : this.form.subCatId,          // 지역
        subCatId: this.form.subCatId,                    // 지역 상세
        itemCd : this.form.itemCd,                       // 품번
        outType : this.form.outType,                     // 환입구분
        confirmYn : this.form.confirmYn,
        procYn : this.form. procYn,                      // 처리상태
        sortType : this.form.sortType,                   // 승인/정산처리유형
        page : this.form.page,
        totalPage : this.form.totalPage,
        curPage : this.form.curPage,
        totalCount : this.form.totalCount,
        processTime : this.form.processTime
      }

      this.$store.commit('loading')
      this.$http.post(_url("/api/workMng/mateReEntering/getExcelList"), vForm)
          .then(response => {
            this.excelData = response.data.map(x => {
              let filter = this.combos['outType'].filter(y => y.key === x.outType);
              x.outType = filter[0].value;
              x.procDt = x.procDt !==null ? this.$moment(x.procDt).format('YYYY-MM-DD') : ''
              x.outDt = x.outDt !==null ? this.$moment(x.outDt).format('YYYY-MM-DD') : ''
              x.inDt = x.inDt !==null ? this.$moment(x.inDt).format('YYYY-MM-DD') : ''
              return x
            });
            /* data customize */
            //this.changeData();
            console.log('this.excelData', this.excelData)

          }).finally(() => {
        this.$store.commit('finish');
        var params = {
          fileName : "자재환입처리"
        };
        this.excelGridOptions.api.exportDataAsExcel(params);

      });
    }
  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  mounted() {
    this.form.companyId = this.$store.state.loginInfo.compCd;
  },
  computed: {
    routeName() {
      return this.$route.name
    }
  },
}
</script>


<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>